import { OutstandingRequisitionsResponse } from '@fnModels/requisitions';
import { OutstandingUndertakingsResponse } from '@fnModels/undertakings';
import { DefaultDashboardSelection } from '@models/businesses';
import { Matter } from '@models/matter';

export interface DashboardModel {
	lastUpdated: number;
	appointments: Matter[];
	closings: Matter[];
	occupancies: Matter[];
	date: number | string;
	filter: DefaultDashboardSelection;
	initialized: boolean;
	loading: boolean; // here
	loadingOutstandingUndertakings: boolean; // @here
	loadingOutstandingRequisitions: boolean; // @here
	loadingUpcomingRequisitionsPurchase: boolean;
	loadingUpcomingRequisitionsSale: boolean;
	requisitions: Matter[];
	upcomingRequisitionsPurchase: Matter[];
	upcomingRequisitionsSale: Matter[];
	outstandingUndertakings: OutstandingUndertakingsResponse[];
	outstandingRequisitions: OutstandingRequisitionsResponse[];
}

export const getDefaultDashboardState = (): DashboardModel => ({
	lastUpdated: new Date().getTime(),
	appointments: [],
	closings: [],
	occupancies: [],
	date: new Date().getTime(),
	filter: null,
	initialized: false,
	loading: false,
	loadingOutstandingUndertakings: false,
	loadingOutstandingRequisitions: false,
	loadingUpcomingRequisitionsPurchase: false,
	loadingUpcomingRequisitionsSale: false,
	requisitions: [],
	upcomingRequisitionsPurchase: [],
	upcomingRequisitionsSale: [],
	outstandingUndertakings: [],
	outstandingRequisitions: [],
});
